import xhr from '../utils/fetch';

const booktrailData = async () => {
  return await xhr({
    url: `/b/getalltrails`,
    method: 'GET'
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

const deleteBooktrail = async (_id: object) => {
  return await xhr({
    url: `/b/deletetrail/${_id}`,
    method: 'DELETE'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const paymentData = async () => {
  return await xhr({
    url: '/b/allpayment',
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const additionalDetail = {
  booktrailData,
  paymentData,
  deleteBooktrail
};
